import { useEffect, useRef } from "react";

export default function CanvasBeach() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const width = (canvas.width = window.innerWidth);
    const height = (canvas.height = window.innerHeight);

    ctx.clearRect(0, 0, width, height);

    const skyHeight = height * 0.4;
    const oceanHeight = height * 0.35;
    const sandStartY = skyHeight + oceanHeight;

    // Draw sky
    ctx.fillStyle = "#87CEEB"; // Light blue
    ctx.fillRect(0, 0, width, skyHeight);

    // Draw ocean with gradient (white at sand edge → blue at sky)
    const gradient = ctx.createLinearGradient(0, skyHeight + oceanHeight, 0, skyHeight);
    gradient.addColorStop(0, "#ffffff");  // Near shore
    gradient.addColorStop(1, "#1E90FF");  // Deep water
    ctx.fillStyle = gradient;
    ctx.fillRect(0, skyHeight, width, oceanHeight);

    // Draw sand with sinusoidal wave top
    const waveAmplitude = 20;
    const waveFrequency = 3;

    ctx.beginPath();
    ctx.moveTo(0, sandStartY);

    for (let x = 0; x <= width; x++) {
      const y =
        sandStartY +
        waveAmplitude * Math.sin((x / width) * waveFrequency * 2 * Math.PI);
      ctx.lineTo(x, y);
    }

    ctx.lineTo(width, height);
    ctx.lineTo(0, height);
    ctx.closePath();
    ctx.fillStyle = "#F4A460"; // Sandy brown
    ctx.fill();
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
    />
  );
}
